'use strict';

import angular from 'angular';
import OauthAuthorizeController from './oauthauthorize.controller.js';

export default angular.module('georgeApp.oauthauthorize', [])
  .controller('OauthAuthorizeController', OauthAuthorizeController)
  .name;
